import CompanyInfoColumns from './CompanyInfoColumns'

export default CompanyInfoColumns
